import { IntegrationSystem } from '@/shared/types';

import { DocumentType, DocumentTypeEntity } from '@/api/types';

export function reformatDocumentTypeToEntity<T extends IntegrationSystem>(
  documentType: DocumentType<T>,
): DocumentTypeEntity<T> {
  return {
    id: documentType.id,
    label: documentType.name,
    code: documentType.code || 'null',
  };
}
